<template>
  <div>
    <div class="login-container">
      <div class="content-container">
          <div v-show="!loginForm.email" class="dingding-wrapper">
            <div class="system-section">
                <img class="logo" src="@/assets/images/dingding/logo.png" alt="logo">
                <p class="name">宝宝巴士统一登录入口</p>
            </div>          
            <div class="login-theme">
              <div id="dd_login_container"></div>
            </div>
          </div>

          <div class="login-form" v-show="loginForm.email">
            <el-form
              :model="loginForm"
              :rules="{}"
              ref="loginForm"
            >
              <el-form-item prop="email">
                <span class="icon-container">
                  <i class="el-icon-user"></i>
                </span>
                <el-input
                  name="email"
                  disabled
                  type="text"
                  v-model.trim="loginForm.email"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
              <el-form-item prop="name">
                <span class="icon-container">
                  <i class="el-icon-user"></i>
                </span>
                <el-input
                  name="name"
                  disabled
                  type="text"
                  v-model.trim="loginForm.name"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <span class="icon-container">
                  <i class="el-icon-s-goods"></i>
                </span>
                <el-input
                  name="password"
                  type="password"
                  @keyup.enter.native="handleLogin"
                  v-model.trim="loginForm.password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  style="width: 100%; margin-top: 20px"
                  @click.native.prevent="handleLogin"
                  >立即登录</el-button
                >
              </el-form-item>
            </el-form>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import genApi from "@/quick/gen-api/";
const { post: loginApi } = genApi("/user/ding_login");
import { getToken, removeToken, setToken } from "@/utils/auth";
import { getHashParam } from "@/utils/common";
import { CONFIG } from "@/config";
const { get: getInfoApi } = genApi("/user/info");

const appid_map = {
  beta: "dingoa2k35fitunfprj1rl",
  master: "dingoa6pngaws3oqtunjky",
};
const appSecret_map = {
  beta: "WZ_axXq-WbC3DjhgWuuv1MGGtUmRJzJzppBxp2XiTG733VEqa4-QFBklL6YBYPnR",
  master: "xI-wMcCaxzJjMl7RbEe0zr2y8zDqyGwsvPavdffl0pZgK8nRktF8mRq04o9KoRKL",
};
const appid = appid_map[CONFIG.domain.getProduction()];
const appSecret = appSecret_map[CONFIG.domain.getProduction()];

export default {
  data() {
    return {
      loginForm: {
        email: "",
        name: "",
        password: "",
      },
    };
  },
  created() {

  },
  mounted(){
    this.$nextTick().then(() => {

      if (getToken()) {
        getInfoApi().then(res=>{
          if(res.status == '0' && res.errcode == 10002){
            removeToken()
            this.initLogin()
          }else{
            removeToken()
            this.initLogin()
            // this.$router.replace({
            //   name: "ML_Index",
            //   query: {
            //     redirect_uri: this.$route.query.redirect_uri,
            //   },
            // });
            return;
          }
        })
      }else{
        this.initLogin()
      }

    });

  },
  methods: {
    initLogin(){
      let link = window.location.href;

      if (link.includes("%3Fcode%3D")) {
        window.location.href = link.replace("%3Fcode%3D", "&code=").replace('%26state%3D','&state=');
        setTimeout(() => {
          this.$route.query.code = getHashParam("code");
          this.dd_login();
        });
        return;
      }
      if (this.$route.query.code) {
        this.dd_login();
      } else {
        this.showDingLogin();
      }

    },
    showDingLogin() {
      /*
       * 解释一下goto参数，参考以下例子：
       * var url = encodeURIComponent('http://localhost.me/index.php?test=1&aa=2');
       * var goto = encodeURIComponent('https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=appid&response_type=code&scope=snsapi_login&state=STATE&redirect_uri='+url)
       */

      let logo =
        "https://baaudio.oss-cn-hangzhou.aliyuncs.com/pinyin/image/2NWqXvkyrnuv58IAbFYPAegvZUUQ0Ad7S5ESZs4r.png ";
      let redirect_uri = window.location.href;
      let goto = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${encodeURIComponent(
        redirect_uri
      )}`;
      let obj = window.DDLogin({
        id: "dd_login_container", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
        goto: encodeURIComponent(goto), //请参考注释里的方式
        style: "border:none;background-color:rgba(255, 255, 255, 0.9);padding: 10px;margin-top: 0",
        width: "250",
        height: "400"
      });
      let handleMessage = () => {
        let origin = event.origin;
        if (origin == "https://login.dingtalk.com") {
          //判断是否来自ddLogin扫码事件。
          let loginTmpCode = event.data;
          window.location.href = `${goto}&loginTmpCode=${loginTmpCode}`;
        }
      };
      if (typeof window.addEventListener != "undefined") {
        window.addEventListener("message", handleMessage, false);
      } else if (typeof window.attachEvent != "undefined") {
        window.attachEvent("onmessage", handleMessage);
      }
    },
    dd_login() {
      this.$store
        .dispatch("user/DDLogin", {
          code: this.$route.query.code,
          state: this.$route.query.state,
        })
        .then((res) => {
          if (res.status == "1") {
            this.loginForm.email = res.data.email;
            this.loginForm.name = res.data.name;
          }
        });
    },
    handleLogin() {
      this.$store
        .dispatch("user/Login", {
          ...this.loginForm,
        })
        .then((res) => {
          if (res.status == "1") {
            this.$router.replace({
              name: "ML_Index",
              query: {
                redirect_uri: this.$route.query.redirect_uri,
              },
            });
          }
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login-container {
  position: absolute;
  width: 100%;
  height: 100%;
  min-width: 600px;
  min-height: 750px;
  background: url("~@/assets/images/bg.png");
  background-size: cover;
  .content-container {
    position: relative;
    top: 50%;
    transform: translateY(-60%);
  }
  .dingding-wrapper {
    position: relative;
    top: 50%;
    transform: translateY(-60%);
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -213px;
    width: 426px !important;
    height: 616px;
    background-image: url("~@/assets/images/dingding/bg_login.png");    
  }
  .header {
    text-align: center;
    .title {
      font-size: 28px;
      color: #fff;
      font-weight: normal;
      margin: 15px 0 7px 0;
      line-height: 1;
    }
    .sub-title {
      font-family: "Verdana";
      font-size: 16px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1;
    }
  }
  .login-form {
    position: relative;
    width: 450px;
    padding: 50px 43px 20px;
    margin: 40px auto;
    background-color: #fff;
    border-radius: 6px;
  }
  .dec-liner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      flex: 1;
      height: 7px;
    }
    .red {
      background-color: #f7653c;
      border-top-left-radius: 6px;
    }
    .green {
      background-color: #c2dc34;
    }
    .blue {
      background-color: #76e3e7;
      border-top-right-radius: 6px;
    }
  }
  .el-form-item {
    position: relative;
    .icon-container {
      position: absolute;
      z-index: 1;
      left: 20px;
      top: 6px;
    }
  }
  input:-webkit-autofill {
    // -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
    -webkit-text-fill-color: #999 !important;
  }
  input {
    background: transparent;
    border: 1px solid #e0e0e0;
    -webkit-appearance: none;
    border-radius: 24px;
    padding: 15px 20px 15px 50px;
    color: #999;
    height: 49px;
  }
  .el-input {
    display: inline-block;
    height: 49px;
    .el-input__inner:focus {
      transition: box-shadow 0.2s ease;
      outline: 0;
      border-color: #535ea7;
      box-shadow: 0 0 10px 0px #535ea7;
    }
  }
  .el-checkbox {
    color: #999;
  }
  .el-form-item__error {
    color: #f7653c;
    display: inline-block;
    position: absolute;
    left: auto;
    right: 19px;
    top: 12px;
  }
  .backend-error {
    position: relative;
    left: 20px;
    top: -12px;
  }
  .el-button {
    background: #42cabf;
    color: #fff;
    font-size: 16px;
    border-radius: 24px;
    height: 49px;
    &:focus,
    &:hover,
    &:active {
      color: #fff;
      border-color: transparent;
      box-shadow: 0 0 10px 0px #535ea7;
    }
  }
}
.tip {
  text-align: center;
  font-size: 12px;
  color: #a8b6cd;
}
.copyright {
  font-size: 16px;
  color: #a8b6cd;
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  text-align: center;
}
.ding-login {
  width: 80px;

  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  &:hover {
    transform-origin: center center;
    transform: scale(1.02, 1.02);

    p {
      color: #3aa2eb;
    }
  }
  p {
    font-size: 16px;
  }
}
.system-section {
  width: 100%;
  text-align: center;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  margin-top: 39px;
  margin-bottom: 30px;  
  img {
    display: inline-block;
    width: 92px;
    height: 110px;    
  }
  p {
    margin-top: -20px;
  }
}
.login-theme {
  width: 250px;
  height: 360px;
  overflow: hidden;
  border-radius: 5px;
  margin: 0 auto;  
}
</style>
